module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCnIt.8b78c36.ttf";